import { IMAGES } from "@/lib/constants";
import { Overline } from "@/components/site/Primitives";
import { NewsletterSection } from "@/components/site/Newsletter";
import { Reveal } from "@/lib/reveal";
import { ExternalLink } from "lucide-react";

const PICKS = [
  { name: "Copper Preserving Pan", note: "The wide, unlined copper pan I've stirred jam in for forty years. Nothing sets a preserve so beautifully.", img: "https://static.prod-images.emergentagent.com/jobs/23aa0e47-791b-4dbb-bfa4-538f8fca177e/images/e5de53110917129fdbfd4ef8a258ee1a154e8d09c18090f550d44c6bf16da5dc.jpeg", cat: "Kitchen", link: "https://amzn.to/4x9MWLp" },
  { name: "Weck Preserving Jars", note: "Glass lids, rubber seals, no rust. The jars that line my larder shelves.", img: "https://images.unsplash.com/photo-1745964276943-5c880fe711bb", cat: "Pantry", link: "https://amzn.to/4hFCfM0" },
  { name: "Linen Apron", note: "Stonewashed linen that softens with every wash. Made to be used, not saved.", img: "https://images.unsplash.com/photo-1760822604131-3bded72f7caf", cat: "Home", link: "https://amzn.to/4xgs718" },
  { name: "Linen Tea Towels", note: "Absorbent, hard-wearing and lovelier with age. Folded by the range in my kitchen.", img: "https://images.unsplash.com/photo-1770731206301-43a9683f3438", cat: "Home", link: "https://amzn.to/4g1wbwe" },
  { name: "Dried Lavender Bunches", note: "For the linen drawer, the bath, and the pillow. English-grown and true.", img: IMAGES.herbHub, cat: "Herbal", link: "https://amzn.to/4vVVogo" },
  { name: "Cast Iron Bread Pot", note: "The lidded pot that gives my loaves their crackling crust. A lifetime purchase.", img: IMAGES.breadHub, cat: "Baking", link: "https://amzn.to/4fMmIYs" },
  { name: "Beeswax Wood Polish", note: "For the old oak table and the dresser. It smells of honey and makes the wood glow.", img: "https://images.unsplash.com/photo-1666013942797-9daa4b8b3b4f", cat: "Home", link: "https://amzn.to/4fv08on" },
  { name: "Teak Carving Board", note: "An end-grain butcher block that's kind to my knives and handsome enough to leave on the counter.", img: "https://static.prod-images.emergentagent.com/jobs/23aa0e47-791b-4dbb-bfa4-538f8fca177e/images/4bd8df79ee2f22de9f8c20c28ace7eb2ff36b0e997adefb522b58fff395f59fd.jpeg", cat: "Kitchen", link: "https://amzn.to/4bQpCKo" },
];

export default function Shop() {
  return (
    <div data-testid="shop-page">
      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-10 text-center">
        <Overline>A few things I love</Overline>
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-light mt-5 mb-6 leading-none">The Affiliate Shop</h1>
        <p className="font-body text-brand-body text-lg max-w-2xl mx-auto leading-relaxed">
          Honest, well-made things I keep and use in my own cottage. Should you buy through these links, I may
          receive a small thank-you — at no cost to you. I only ever share what I truly love.
        </p>
      </section>
      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16">
          {PICKS.map((p, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08}>
              <div className="group" data-testid={`shop-item-${i}`}>
                <div className="overflow-hidden bg-brand-warm-white border border-brand-linen">
                  <img src={p.img} alt={p.name} className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <span className="overline text-[0.62rem] mt-5 block">{p.cat}</span>
                <h3 className="font-serif text-2xl mt-1">{p.name}</h3>
                <p className="font-body text-brand-muted mt-2 leading-relaxed">{p.note}</p>
                {p.link ? (
                  <a href={p.link} target="_blank" rel="noopener noreferrer sponsored" data-testid={`shop-link-${i}`} className="link-underline inline-flex items-center gap-2 mt-4 font-sans text-xs uppercase tracking-[0.16em] text-brand-copper">
                    View item <ExternalLink size={13} />
                  </a>
                ) : (
                  <a href="#" onClick={(e) => e.preventDefault()} className="link-underline inline-flex items-center gap-2 mt-4 font-sans text-xs uppercase tracking-[0.16em] text-brand-copper">
                    View item <ExternalLink size={13} />
                  </a>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <NewsletterSection />
    </div>
  );
}
